import * as ActionTypes from '../redux/ActionTypes';

export default (state=[], action) => {
  if (action.type === ActionTypes.SETCOMPETITION) {
    return  [ ...state, ...action.competitions ];
  } else {
    return state;
  }
}